import { useInputContext } from '../useInput';
import { InterfaceAction } from '../../data/controls.config';

export type MenuAction =
  | 'up'
  | 'down'
  | 'left'
  | 'right'
  | 'confirm'
  | 'cancel'
  | 'unpause'
  | 'tabNext'
  | 'tabPrev'
  | 'secondary'
  | 'tertiary'
  | 'quaternary'
  | 'details';

// A handler may return `false` to signal a denied action (drives the error cue
// in the central interface-sound dispatch). See useInput.ts.
export type MenuHandlers = Partial<Record<MenuAction, () => void | boolean>>;

const MENU_ACTION_TO_INTERFACE: Record<MenuAction, InterfaceAction> = {
  up: 'UP',
  down: 'DOWN',
  left: 'LEFT',
  right: 'RIGHT',
  confirm: 'CONFIRM',
  cancel: 'CANCEL',
  unpause: 'UNPAUSE',
  tabNext: 'TAB_NEXT',
  tabPrev: 'TAB_PREV',
  secondary: 'SECONDARY',
  tertiary: 'TERTIARY',
  quaternary: 'QUATERNARY',
  details: 'DETAILS',
};

const REPEATABLE_INTERFACE_ACTIONS: ReadonlyArray<InterfaceAction> = [
  'UP',
  'DOWN',
  'LEFT',
  'RIGHT',
];

export function useMenuInput(handlers: MenuHandlers, disabled = false): void {
  const interfaceHandlers: Partial<
    Record<InterfaceAction, () => void | boolean>
  > = {};
  for (const menuAction in handlers) {
    const cb = handlers[menuAction as MenuAction];
    if (cb) {
      interfaceHandlers[MENU_ACTION_TO_INTERFACE[menuAction as MenuAction]] =
        cb;
    }
  }

  useInputContext('interface', {
    handlers: interfaceHandlers,
    repeatable: REPEATABLE_INTERFACE_ACTIONS,
    disabled,
  });
}
